import { apiCartTokenTrack } from '../../analytics/tracker/events/bugTrack';
import { GET_CART, UPDATE_CART_BILL_API } from '../../axios/appiendPoints';
import { axiosInstance } from '../../axios/axios';
import { DELIVERY_TYPE, PICKUP_TYPE } from '../../webStorage/keys/sessionKeys';
import { getLocalItem, getUserToken } from '../../webStorage/localStorage';
import { getOrderType, getOrderTypeSession, getTableId } from '../../webStorage/manageOrderType';
import { getSkipPackagingCharges } from '../../webStorage/sessionStorage';
import {
  CART_LOADER,
  DELETE_CART,
  DELETE_CART_BILL,
  UPDATE_CART,
  UPDATE_CART_BILL,
  UPDATE_LOYALITY,
} from './cartTypes';

export const setCartInRedux = (type, cart) => {
  switch (type) {
    case 2: {
      return { type: CART_LOADER };
    }
    case 1: {
      return {
        type: UPDATE_CART,
        payload: cart,
      };
    }
    case 0: {
      return {
        type: DELETE_CART,
      };
    }

    default: {
      // console.log('cart cananot be changed');
      return;
    }
  }
};

export const setCartBillInRedux = (type, cartBill) => {
  switch (type) {
    case 1: {
      return {
        type: UPDATE_CART_BILL,
        payload: cartBill,
      };
    }
    case 0: {
      return {
        type: DELETE_CART_BILL,
      };
    }

    default: {
      return;
    }
  }
};

export const setLoyalityInRedux = (loyality) => {
  return {
    type: UPDATE_LOYALITY,
    payload: loyality,
  };
};

export const getCartFunction = (cartToken, restarantId) => {
  let orderType = getOrderType();
  let params = new URLSearchParams();
  const sessionSetting = getOrderTypeSession();
  if (
    (orderType == DELIVERY_TYPE || orderType == PICKUP_TYPE) &&
    sessionSetting.orderTime == 'SCHEDULED' &&
    sessionSetting?.epoch > parseInt(Date.now() / 1000)
  ) {
    params.append('epoch', sessionSetting?.epoch);
    // console.log('time scheduled');
  }
  params.append('restaurant_id', restarantId);
  params.append('cart_token', cartToken);
  apiCartTokenTrack({
    fileName: 'cartActions.js',
    functionName: 'getCartFunction',
    cartToken: cartToken || cartToken + '',
  });
  params.append('table_id', getTableId());
  params.append('token', getUserToken());
  return (dispatch) => {
    if (!cartToken) return;

    dispatch(setCartInRedux(2, CART_LOADER));
    axiosInstance
      .post(GET_CART, params)
      .then((response) => {
        dispatch(setCartInRedux(1, response.data.data.cart));
      })
      .catch((err) => {
        console.error(err.message);
      });
  };
};

export const getCartBillFunction = (
  customerAddress = '',
  cartToken,
  restarantId,
  customerLocation = [],
  platform = 'easyeat'
) => {
  let orderType = getOrderType();
  let params = new URLSearchParams();
  const sessionSetting = getOrderTypeSession();

  if (
    (orderType == DELIVERY_TYPE || orderType == PICKUP_TYPE) &&
    sessionSetting.orderTime == 'SCHEDULED' &&
    sessionSetting?.epoch > parseInt(Date.now() / 1000)
  ) {
    params.append('epoch', sessionSetting?.epoch);
  }
  params.append('customer_address', customerAddress);
  params.append('restaurant_id', restarantId);
  params.append('cart_token', cartToken);
  apiCartTokenTrack({
    fileName: 'cartActions.js',
    functionName: 'getCartBillFunction',
    cartToken: cartToken || cartToken + '',
  });
  params.append(
    'order_type',
    sessionSetting?.orderType ? sessionSetting?.orderType : getLocalItem('ot')
  );
  params.append('customer_location', customerLocation);
  params.append('platform', platform);
  const skipPackaging = getSkipPackagingCharges();
  params.append('skip_packaging_charge_operation', skipPackaging || 0);
  return (dispatch) => {
    axiosInstance
      .post(UPDATE_CART_BILL_API, params)
      .then((response) => {
        // checking if status is 1 and there is item in cart
        if (response.data.status == 1) {
          dispatch(setCartBillInRedux(1, response.data.data));
        } else {
          dispatch(setCartBillInRedux(1, {}));
          try {
            window.__bgtracker.track('GET_CART_BILL', {
              hitName: 'GET_CART_BILL',
              cart_params: {
                customer_address: customerAddress,
                restaurant_id: restarantId,
                cart_token: cartToken,
                order_type: orderType,
                customer_location: customerLocation,
                platform: platform,
                skip_packaging_charge_operation: skipPackaging || 0,
              },
              cart_response: response.data.data,
              status: response.data.status,
            });
          } catch (err) {
            console.log(err);
          }
        }
      })
      .catch((err) => {
        console.error(err?.response?.data.message);
      });
  };
};
